<template>
  <b-pagination
    v-show="listado.length > 0"
    v-model="paginaActual"
    :total-rows="listado.length"
    :per-page="perPage"
    limit="5"
    class="col-md-4 mx-auto px-0"
    align="center"
  ></b-pagination>
</template>

<script>
export default {
  name: "Paginacion",
  props: {
    listado: {
      type: Array
    },
    perPage: {
      type: Number
    },
    paginaInicio: {
      type: Number
    }
  },
  data() {
    return {
      paginaActual: 1
    };
  },
  watch: {
    paginaActual() {
      this.paginaInstituciones(this.listado, this.paginaActual);
    },
    listado() {
      this.paginaInstituciones(this.listado, this.paginaActual);
    }
  },
  methods: {
    paginaInstituciones(instituciones, pagina) {
      let arreglo = [];
      if (instituciones.length > 0) {
        let inicio = (pagina - 1) * this.perPage;
        let final =
          pagina * this.perPage > instituciones.length
            ? instituciones.length
            : pagina * this.perPage;
        arreglo = instituciones.slice(inicio, final);
      }
      this.$emit("listadoArreglos", arreglo);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/Paginacion.vue